import { Tooltip } from "@mui/material";
import React from "react";
import ReactTimeAgo from "react-time-ago";

import { Typography } from "new-components/typography/Typography";
import { parseDateAsUTC } from "utils/utilityFunctions";

function AccuracyTimestamp({ mlAccuracyTimestamp }: { mlAccuracyTimestamp?: string }) {
  return mlAccuracyTimestamp ? (
    <Tooltip title="Last updated">
      <Typography variant="small" height="20px" color="white" alignSelf="end">
        (Accuracy % calculated
        <ReactTimeAgo className="ms-1" date={parseDateAsUTC(mlAccuracyTimestamp)} locale="en-US" />)
      </Typography>
    </Tooltip>
  ) : (
      <Typography
        variant="small"
        textTransform="uppercase"
        height="20px"
        className="text-white"
      >
        -
      </Typography>
  );
}

export default AccuracyTimestamp;
